import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import Choices from 'choices.js';

const mapCallOuts = document.querySelectorAll('.callout--economic-global-warming-map');
let timer;
let isPlaying = false;
const defaultZoom = 0.5;
const minZoom = 0.5;

mapboxgl.accessToken =
	'pk.eyJ1IjoicnlhbnJleW5vbGRzIiwiYSI6ImNqemRkemRjdzA0dDQzYmp2d21waWR5NDkifQ.Sddp5xSThFCTBvUFqID1ZA';

const sort = (arr) => arr.sort((a, b) => a - b);

const getInterval = (num, dataArray) => {
	const maxVal = num;
	const delta = Math.floor(dataArray.length / maxVal);

	const data = [];
	for (let i = 0; i < dataArray.length; i += delta) {
		data.push(dataArray[i]);
	}

	return data;
};

/**
 * Colors
 *
 * @param   {number}  selectValueIndex  Selected select option index
 * @param   {string}  type              Color array to return  map || legend
 * @param   {number}  min 				Min Value
 * @param   {number}  max 				Max Value
 * @param   {number}  year 				Year to show
 *
 * @returns  {Array}                     Color array
 */

// eslint-disable-next-line default-param-last
function colorsToUse(selectValueIndex, type = 'map', min, max, year = 'U2400') {
	const grad1 = ['#ff3838', '#1a1a1a', '#00d8f0'];

	// const grad2 = ['#f18a41', '#1a1a1a', '#7d3cff'];

	let colorArray;

	// if (parseInt(selectValueIndex, 10) === 0 || parseInt(selectValueIndex, 10) === 1) {
	// 	if (type === 'map') {
	// 		colorArray = [
	// 			'interpolate',
	// 			['linear'],
	// 			['get', year],
	// 			-9999.0,
	// 			'#ccc',
	// 			min,
	// 			grad1[0],
	// 			1,
	// 			grad1[1],
	// 			max,
	// 			grad1[2],
	// 		];
	// 	} else if (type === 'legend') {
	// 		colorArray = grad1;
	// 	}
	// } else if (type === 'map') {
	// 	colorArray = [
	// 		'interpolate',
	// 		['linear'],
	// 		['get', year],
	// 		-9999.0,
	// 		'#ccc',
	// 		min,
	// 		grad2[0],
	// 		1,
	// 		grad2[1],
	// 		max,
	// 		grad2[2],
	// 	];
	// } else if (type === 'legend') {
	// 	colorArray = grad2;
	// }

	if (type === 'map') {
		const median = max < 1 ? (min + max) / 2 : 1;
		colorArray = [
			'interpolate',
			['linear'],
			['get', year],
			-9999.0,
			'#ccc',
			min,
			grad1[0],
			median,
			grad1[1],
			max,
			grad1[2],
		];
	} else if (type === 'legend') {
		colorArray = grad1;
	}

	return colorArray;
}

const getAllValues = (data) => {
	let values = [];
	for (let i = 0; i < data.length; i++) {
		const years = Object.entries(data[i].properties).filter((v) => v[0].charAt(0) === 'U');

		for (let j = 0; j < years.length; j++) {
			const year = years[j];
			if (year[1] !== 0 && year[1] !== -9999.0) {
				values.push(year[1]);
			}
		}
	}

	// Remove Duplicates
	values = [...new Set(values)];

	values = sort(values);
	values.reverse();

	return values;
};

const buildLegend = (data, elm, selectValueIndex) => {
	const gradient = elm.querySelector('.gradient');
	const legendTicksElm = elm.querySelector('.legend-ticks');

	const min = data[data.length - 1];
	const max = data[0];

	const tickValues = data
		.map((v) => Number.parseFloat(v.toFixed(2)))
		.reduce((unique, item) => (unique.includes(item) ? unique : [...unique, item]), []);

	const legendTicks = getInterval(6, tickValues);

	legendTicksElm.innerHTML = '';
	// console.log('legendTicks', legendTicks);
	for (let index = 0; index < legendTicks.length; index++) {
		const tick = legendTicks[index];
		const div = document.createElement('div');
		div.classList.add('tick');
		div.innerHTML = tick.toFixed(2);
		legendTicksElm.append(div);
	}
	const colors = colorsToUse(selectValueIndex, 'legend', min, max);
	gradient.style.background = `linear-gradient(40deg, ${colors[0]} 0%, ${colors[1]} 50%, ${colors[2]} 100%)`;
};

const buildRangeSlider = (data, yearRangeSlider, rangeSliderTicks) => {
	if (data) {
		const years = Object.entries(data[0].properties).filter((v) => v[0].charAt(0) === 'U');

		rangeSliderTicks.innerHTML = '';
		yearRangeSlider.min = years[0][0].substring(1);
		yearRangeSlider.max = years[years.length - 1][0].substring(1);
		// yearRangeSlider.value = years[0][0].substring(1); // First Year
		yearRangeSlider.value = years[years.length - 1][0].substring(1); // Latest Year

		const rangeYearData = getInterval(10, years, rangeSliderTicks);

		// Add ticks
		for (let index = 0; index < rangeYearData.length; index++) {
			const element = rangeYearData[index][0];
			const div = document.createElement('div');
			div.classList.add('tick');
			div.innerHTML = element.substring(1);
			rangeSliderTicks.append(div);
		}
	}
};

const pause = (btn) => {
	clearInterval(timer);
	isPlaying = false;
	btn.querySelector('span').innerHTML = 'Play';
	btn.classList.add('is-paused');
	btn.classList.remove('is-playing');
};

const play = (num, max, btn, yearRangeSlider, step) => {
	isPlaying = true;
	btn.classList.remove('is-paused');
	btn.classList.add('is-playing');
	btn.querySelector('span').innerHTML = 'Pause';
	timer = setInterval(function () {
		// eslint-disable-next-line no-param-reassign
		num = parseInt(num + step, 10);
		yearRangeSlider.value = num;
		yearRangeSlider.dispatchEvent(new Event('change'));
		if (num === max) {
			pause(btn);
			btn.querySelector('span').innerHTML = 'Restart';
		}
	}, 150);
};

/**
 * Update related chart data
 *
 * @param   {object}  htmlElm  [htmlElm description]
 * @param   {string}  data     [data description]
 * @param   {string}  defaultText     [data description]
 */
function updateTextContent(htmlElm, data, defaultText) {
	if (htmlElm) {
		if (data || defaultText) {
			htmlElm.innerHTML = data || defaultText;
			htmlElm.classList.add('is-visible');
			htmlElm.classList.remove('is-hidden');
		} else {
			htmlElm.classList.remove('is-visible');
			htmlElm.classList.add('is-hidden');
		}
	}
}

function generateSelect(data, selectElm) {
	const selections = [];

	/**
	 * Generate Select Options
	 *
	 * @param   {object}  chart  [chart description]
	 * @param   {number}  index  [index description]
	 */
	data.forEach((mapData, index) => {
		const selected = index === 0;
		const option = {
			value: index,
			label: mapData.title,
			selected,
		};
		selections.push(option);
	});

	/**
	 * Active Choices Js
	 *
	 * @param   {object}  select  [select description]
	 */
	/* eslint-disable no-unused-vars */
	const choices = new Choices(selectElm, {
		searchEnabled: false,
		shouldSort: false,
		choices: selections,
		itemSelectText: '',
		position: 'bottom',
		classNames: {
			containerOuter: 'choices choices--map',
		},
	});
}

function closeModal(mapCallOut, calloutWrapper, map, button) {
	const body = document.querySelector('body');

	button.classList.remove('is-expanded');
	mapCallOut.classList.remove('is-expanded');

	calloutWrapper.appendChild(mapCallOut);

	document.querySelector('.callout-modal-bg').remove();

	body.classList.remove('modal-open');

	map.resize();
	// map.setZoom(defaultZoom);
	map.setMinZoom(minZoom);
	map.jumpTo({
		zoom: defaultZoom,
	});
}

function openModal(mapCallOut, calloutWrapper, map, button) {
	mapCallOut.classList.add('is-expanded');
	const body = document.querySelector('body');

	// create background div
	// create a new div element
	const bgElm = document.createElement('div');
	bgElm.classList.add('callout-modal-bg');

	// add the newly created element and its content into the DOM

	body.append(bgElm);
	body.classList.add('modal-open');

	bgElm.appendChild(mapCallOut);

	map.resize();

	map.setZoom(1.25);

	map.setMinZoom(1.25);

	// Move callout contents into bg div
	// document.body.insertAfter(mapCallOut, bgElm);

	bgElm.addEventListener('click', function (e) {
		if (e.target !== this) {
			return;
		}

		closeModal(mapCallOut, calloutWrapper, map, button);
	});
}

mapCallOuts.forEach((mapCallOut) => {
	const legend = mapCallOut.querySelector('.legend');
	const yearRangeSlider = mapCallOut.querySelector('.year-range-slider');
	const yearRangeSliderStep = yearRangeSlider.size;
	const rangeSliderTicks = mapCallOut.querySelector('.range-slider-ticks');
	const btnRangePlay = mapCallOut.querySelector('.btn--range-play');
	const datasetSelect = mapCallOut.querySelector('.map-dataset-select');
	const { datasetId } = mapCallOut.dataset;
	const mapContainer = mapCallOut.querySelector('.map');
	const calloutWrapper = mapCallOut.closest('.callout-wrapper');
	const subTitle = mapCallOut.querySelector('.callout__subtitle');
	const source = mapCallOut.querySelector('.callout__source');
	const content = mapCallOut.querySelector('.callout__content .textblock');
	const btnExpand = mapCallOut.querySelector('.btn--expand');
	let selectedYear;

	/**
	 * Get Wp Data
	 *
	 * @param   interger  datasetId   Dataset Post ID
	 */
	fetch(`/wp-json/wp/v2/datasets/${datasetId}`)
		.then((response) => {
			if (response.ok) {
				return Promise.resolve(response);
			}
			return Promise.reject(new Error('Failed to load'));
		})
		.then((response) => response.json()) // parse response as JSON
		.then((data) => {
			// console.log('wpdata', data);

			const acfData = data.acf;
			const { datasets } = acfData.economic_affects_of_global_warming_map;

			const mapDataUrl = data.acf.economic_affects_of_global_warming_map.datasets[0].dataset;

			generateSelect(datasets, datasetSelect);

			updateTextContent(subTitle, datasets[0].subtitle, acfData.global_subtitle);
			updateTextContent(source, datasets[0].source, acfData.global_source);
			updateTextContent(content, datasets[0].note, acfData.description);

			const map = new mapboxgl.Map({
				container: mapContainer,
				style: 'mapbox://styles/ryanreynolds/ckwmfpbgu10yh16lh3rk0p5tc',
				// style: 'mapbox://styles/ryanreynolds/ckydb06lz8sa214qsarm67zwf', // blank
				// center: [0, 20],
				// zoom: defaultZoom,
				minZoom,
				renderWorldCopies: false,
				pitchWithRotate: false,
				bearing: 0,
				dragRotate: false,
				attributionControl: false,
			});

			let selectValueIndex = datasetSelect.selectedIndex;

			// Add zoom and rotation controls to the map.
			const nav = new mapboxgl.NavigationControl({
				showCompass: false,
			});
			map.addControl(nav, 'top-left');

			map.on('load', () => {
				// window.dispatchEvent(new Event('resize'));

				map.setZoom(defaultZoom);

				// map.flyTo({
				// 	center: [20, 20],
				// });

				map.addSource('my-data', {
					type: 'geojson',
					data: mapDataUrl,
				});

				/**
				 * rangeSliderSet is so that the slider does not get updated each time a new dataset year is chosen
				 */
				let rangeSliderSet = false;

				let values;
				let max;
				let min;

				/**
				 * Mapbox on souredata
				 */
				map.on('sourcedata', function () {
					let legendSet = false;
					const features = map.querySourceFeatures('my-data');

					if (features[0]) {
						values = getAllValues(features);

						max = values[0];
						min = values[values.length - 1];

						if (!rangeSliderSet) {
							buildRangeSlider(features, yearRangeSlider, rangeSliderTicks);
							selectedYear = yearRangeSlider.value;
							rangeSliderSet = true;
						}

						if (!legendSet) {
							buildLegend(values, legend, selectValueIndex);
							legendSet = true;
						}

						if (!isPlaying) {
							// console.log('features', selectValueIndex, features);
							// console.log('values', selectValueIndex, values);

							map.setPaintProperty(
								'hex-data',
								'fill-color',
								colorsToUse(selectValueIndex, 'map', min, max),
							);
						}

						// console.log('selectedYear', selectedYear);
					}
				});

				map.addLayer({
					id: 'hex-data',
					type: 'fill',
					source: 'my-data',
					layout: {},
				});

				map.addLayer({
					id: 'water-shadow',
					type: 'fill',
					source: 'composite',
					'source-layer': 'water',
					paint: {
						'fill-translate-anchor': 'viewport',
						'fill-translate': [
							'interpolate',
							['exponential', 1.2],
							['zoom'],
							7,
							['literal', [0, 0]],
							16,
							['literal', [-1, -1]],
						],
						'fill-color': 'hsl(197, 0%, 100%)',
					},
				});

				map.addLayer({
					id: 'admin-1-boundary-bg',
					type: 'line',
					source: 'composite',
					'source-layer': 'admin',
					filter: [
						'all',
						['==', ['get', 'admin_level'], 1],
						['==', ['get', 'maritime'], 'false'],
						['match', ['get', 'worldview'], ['all', 'US'], true, false],
					],
					layout: { 'line-join': 'bevel' },
					paint: {
						'line-blur': ['interpolate', ['linear'], ['zoom'], 3, 0, 8, 3],
						'line-width': ['interpolate', ['linear'], ['zoom'], 7, 3.75, 12, 5.5],
						'line-opacity': ['interpolate', ['linear'], ['zoom'], 7, 0, 8, 0.75],
						'line-dasharray': [1, 0],
						'line-translate': [0, 0],
						'line-color': 'hsl(0, 0%, 84%)',
					},
				});

				map.addLayer({
					id: 'admin-0-boundary-bg',
					type: 'line',
					source: 'composite',
					'source-layer': 'admin',
					minzoom: 1,
					filter: [
						'all',
						['==', ['get', 'admin_level'], 0],
						['==', ['get', 'maritime'], 'false'],
						['match', ['get', 'worldview'], ['all', 'US'], true, false],
					],
					paint: {
						'line-width': ['interpolate', ['linear'], ['zoom'], 3, 3.5, 10, 8],
						'line-color': 'hsl(0, 0%, 84%)',
						'line-opacity': ['interpolate', ['linear'], ['zoom'], 3, 0, 4, 0.5],
						'line-translate': [0, 0],
						'line-blur': ['interpolate', ['linear'], ['zoom'], 3, 0, 10, 2],
					},
				});

				map.addLayer({
					id: 'admin-1-boundary',
					type: 'line',
					source: 'composite',
					'source-layer': 'admin',
					filter: [
						'all',
						['==', ['get', 'admin_level'], 1],
						['==', ['get', 'maritime'], 'false'],
						['match', ['get', 'worldview'], ['all', 'US'], true, false],
					],
					layout: { 'line-join': 'round', 'line-cap': 'round' },
					paint: {
						'line-dasharray': [
							'step',
							['zoom'],
							['literal', [2, 0]],
							7,
							['literal', [2, 2, 6, 2]],
						],
						'line-width': ['interpolate', ['linear'], ['zoom'], 7, 0.75, 12, 1.5],
						'line-opacity': ['interpolate', ['linear'], ['zoom'], 2, 0, 3, 1],
						'line-color': [
							'interpolate',
							['linear'],
							['zoom'],
							3,
							'hsl(0, 0%, 80%)',
							7,
							'hsl(0, 0%, 70%)',
						],
					},
				});

				map.addLayer({
					id: 'admin-0-boundary',
					type: 'line',
					source: 'composite',
					'source-layer': 'admin',
					minzoom: 1,
					filter: [
						'all',
						['==', ['get', 'admin_level'], 0],
						['==', ['get', 'disputed'], 'false'],
						['==', ['get', 'maritime'], 'false'],
						['match', ['get', 'worldview'], ['all', 'US'], true, false],
					],
					layout: { 'line-join': 'round', 'line-cap': 'round' },
					paint: {
						'line-color': 'hsl(0, 0%, 62%)',
						'line-width': ['interpolate', ['linear'], ['zoom'], 3, 0.5, 10, 2],
					},
				});

				map.addLayer({
					id: 'admin-0-boundary-disputed',
					type: 'line',
					source: 'composite',
					'source-layer': 'admin',
					minzoom: 1,
					filter: [
						'all',
						['==', ['get', 'disputed'], 'true'],
						['==', ['get', 'admin_level'], 0],
						['==', ['get', 'maritime'], 'false'],
						['match', ['get', 'worldview'], ['all', 'US'], true, false],
					],
					layout: { 'line-join': 'round' },
					paint: {
						'line-dasharray': [1.5, 1.5],
						'line-color': 'hsl(0, 0%, 62%)',
						'line-width': ['interpolate', ['linear'], ['zoom'], 3, 0.5, 10, 2],
					},
				});

				map.addLayer({
					id: 'country-labels',
					type: 'symbol',
					source: 'composite',
					'source-layer': 'place_label',
					// minzoom: 1,
					// maxzoom: 10,
					// filter: ['==', ['get', 'class'], 'country'],
					layout: {
						'text-line-height': 1.1,
						'text-size': [
							'interpolate',
							['cubic-bezier', 0.2, 0, 0.7, 1],
							['zoom'],
							-3,
							['step', ['get', 'symbolrank'], 11, 4, 9, 5, 8],
							9,
							['step', ['get', 'symbolrank'], 28, 4, 22, 5, 21],
						],
						'icon-image': 'dot-11',
						// 'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Regular'],
						'text-justify': [
							'step',
							['zoom'],
							[
								'match',
								['get', 'text_anchor'],
								['left', 'bottom-left', 'top-left'],
								'left',
								['right', 'bottom-right', 'top-right'],
								'right',
								'center',
							],
							-3,
							'center',
						],
						// visibility: 'none',
						'text-offset': [
							'step',
							['zoom'],
							[
								'match',
								['get', 'text_anchor'],
								'bottom',
								['literal', [0, -0.25]],
								'bottom-left',
								['literal', [0.2, -0.05]],
								'left',
								['literal', [0.4, 0.05]],
								'top-left',
								['literal', [0.2, 0.05]],
								'top',
								['literal', [0, 0.25]],
								'top-right',
								['literal', [-0.2, 0.05]],
								'right',
								['literal', [-0.4, 0.05]],
								'bottom-right',
								['literal', [-0.2, -0.05]],
								['literal', [0, -0.25]],
							],
							7,
							['literal', [0, 0]],
						],
						'text-anchor': [
							'step',
							['zoom'],
							['coalesce', ['get', 'text_anchor'], 'center'],
							7,
							'center',
						],
						'text-field': ['coalesce', ['get', 'name_en'], ['get', 'name']],
						'text-max-width': 6,
					},
					paint: {
						'icon-opacity': [
							'step',
							['zoom'],
							['case', ['has', 'text_anchor'], 1, 0],
							7,
							0,
						],
						'text-color': '#fff',
						// 'text-halo-color': [
						// 	'interpolate',
						// 	['linear'],
						// 	['zoom'],
						// 	2,
						// 	'rgba(0,0,0,0.75)',
						// 	3,
						// 	'rgba(0,0,0,0.75)',
						// ],
						'text-halo-color': 'rgba(0,0,0,0.5)',
						'text-halo-width': 1,
					},
				});

				// Set callout height so the page doesn't jump when the modal opens
				calloutWrapper.style.height = `${calloutWrapper.offsetHeight}px`;

				btnRangePlay.addEventListener('click', function () {
					const num = parseInt(yearRangeSlider.value, 10);
					const minValue = parseInt(yearRangeSlider.min, 10);
					const maxValue = parseInt(yearRangeSlider.max, 10);
					if (!isPlaying) {
						if (num === maxValue) {
							yearRangeSlider.value = minValue;
							play(
								minValue,
								maxValue,
								btnRangePlay,
								yearRangeSlider,
								yearRangeSliderStep,
							);
						} else {
							play(num, maxValue, btnRangePlay, yearRangeSlider, yearRangeSliderStep);
						}
					} else {
						pause(btnRangePlay);
					}
				});

				yearRangeSlider.addEventListener('change', (e) => {
					isPlaying = true;
					selectedYear = e.target.value;
					const colors = colorsToUse(
						selectValueIndex,
						'map',
						min,
						max,
						`U${selectedYear}`,
					);

					map.setPaintProperty('hex-data', 'fill-color', colors);
				});

				yearRangeSlider.addEventListener('input', function () {
					pause(btnRangePlay);
				});

				datasetSelect.addEventListener('change', function (event) {
					selectValueIndex = this.value;
					const updatedData =
						data.acf.economic_affects_of_global_warming_map.datasets[selectValueIndex];
					map.getSource('my-data').setData(updatedData.dataset);

					updateTextContent(subTitle, updatedData.subtitle, acfData.global_subtitle);
					updateTextContent(source, updatedData.source, acfData.global_source);
					updateTextContent(content, updatedData.note, acfData.description);

					calloutWrapper.style.height = 'auto';
					calloutWrapper.style.height = `${calloutWrapper.offsetHeight}px`;
				});

				btnExpand.addEventListener('click', function () {
					this.classList.toggle('is-expanded');
					if (mapCallOut.classList.contains('is-expanded')) {
						closeModal(mapCallOut, calloutWrapper, map, this);
					} else {
						openModal(mapCallOut, calloutWrapper, map, this);
					}
				});
			});
		});
});
